import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as echarts from 'echarts';

import "./assets/css/base.css"
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueAxios, axios);

import request from "./utils/request.js"
import requestForReport from "./utils/requestForReport.js"
import formatTime from "./utils/formatTime.js"

Vue.prototype.$request = request
Vue.prototype.$requestForReport = requestForReport
Vue.prototype.$formatTime = formatTime
Vue.prototype.$echarts = echarts

Vue.prototype.$technicalSupport = "技术支持：@安徽弛振科技有限公司" // 技术支持

// Vue.prototype.$baseurl = 'http://47.98.44.199:6654/api'

// Vue.prototype.$baseurl = 'http://192.168.0.188:6654' // 汪晶

// Vue.prototype.$baseurl = 'http://47.122.21.185:6654'

Vue.prototype.$baseurl = 'http://zsb.ah-cz.cn/api' // 城市学院域名
// Vue.prototype.$baseurl = 'http://www.meltrylls.cn/api' // 弛振域名

// Vue.prototype.$baseurl = 'http://dksxbm.axhu.edu.cn/api' // 新华域名

// Vue.prototype.$baseurl = 'http://192.168.0.100:61228' //100 本地部署


import * as baseData from "./assets/js/base.js"
Vue.prototype.$baseData = baseData

import diy_search from "./components/search/"
Vue.use(diy_search)

import diy_dialog from "./components/diy_dialog/"
Vue.use(diy_dialog)

import dialog_table from "./components/dialog_table/"
Vue.use(dialog_table)

import diy_infomation from "./components/infomation/"
Vue.use(diy_infomation)


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        "inline": true,
        "button": true,
        "navbar": true,
        "title": true,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true,
        "url": "data-source"
    }
});

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
    config => {
        if (window.sessionStorage.getItem('token')) {
            config.headers.token = window.sessionStorage.getItem('token')
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
